var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.entity_account"),
        "show-filter": _vm.tabName === 1 || _vm.tabName === 2,
        "show-refresh": _vm.tabName === 1 || _vm.tabName === 2,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": false,
      },
      on: { "toggle-filter": _vm.openFilter, refresh: _vm.refresh },
    },
    [
      _c("template", { slot: "navigationTabs" }, [
        _c("div", { staticClass: "d-block d-lg-none" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("app-button", {
                key: index,
                attrs: {
                  text: _vm.$t(tab.translationKey),
                  variant: _vm.tabName === tab.value ? "primary" : "light",
                  size: "md",
                  block: true,
                  "custom-class": "mb-2",
                  "aria-pressed": _vm.tabName === tab.value ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    return _vm.changeTabName(tab.value)
                  },
                },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-lg-block" },
          [
            _c(
              "b-nav",
              {
                staticClass: "border-0",
                attrs: { tabs: "", fill: "", role: "tablist" },
              },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c(
                  "b-nav-item",
                  {
                    key: index,
                    class: { "bg-dark text-white": _vm.tabName === tab.value },
                    attrs: {
                      active: _vm.tabName === tab.value,
                      id: "tab-entityaccount-" + tab.value,
                      role: "tab",
                      "aria-selected":
                        _vm.tabName === tab.value ? "true" : "false",
                      "aria-controls": "tabpanel-entityaccount-" + tab.value,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeTabName(tab.value)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "font-weight-bold": _vm.tabName === tab.value,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(tab.translationKey)) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.tabName === 1 || _vm.tabName === 2
        ? _c(
            "template",
            { slot: "filterContent" },
            [
              _c("app-panel", {
                attrs: {
                  filters: _vm.filterConfig,
                  searchAriaLabel:
                    _vm.$t("common.srch") +
                    " " +
                    _vm.$t("Webheader.entity_account_file"),
                },
                on: {
                  "filter-changed": _vm.onFilterChanged,
                  "clear-filters": _vm.clearFilterFields,
                  "apply-filters": _vm.applyFilters,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _vm.tabName === 1
                ? _c(
                    "div",
                    {
                      attrs: {
                        role: "tabpanel",
                        id: "tabpanel-entityaccount-1",
                        "aria-labelledby": "tab-entityaccount-1",
                      },
                    },
                    [_c("EntityAccountFileList")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tabName === 2
                ? _c(
                    "div",
                    {
                      attrs: {
                        role: "tabpanel",
                        id: "tabpanel-entityaccount-2",
                        "aria-labelledby": "tab-entityaccount-2",
                      },
                    },
                    [_c("EntityAccountList")],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }